import { http, Result } from "@fider/services/http"
import { Department, DepartmentType } from "@fider/models"

export const createDepartment = async (name: string, type: DepartmentType, parentID?: number): Promise<Result<Department>> => {
  return http.post<Department>(`/api/v1/departments`, { name, type, parentID }).then(http.event("department", "create"))
}

export const updateDepartment = async (id: number, name: string, type: DepartmentType, parentID?: number): Promise<Result<Department>> => {
  return http.put<Department>(`/api/v1/departments/${id}`, { name, type, parentID }).then(http.event("department", "update"))
}

export const deleteDepartment = async (id: number): Promise<Result> => {
  return http.delete(`/api/v1/departments/${id}`).then(http.event("department", "delete"))
}
